import { render, staticRenderFns } from "./bussiness.vue?vue&type=template&id=c9a8cbe4&scoped=true"
import script from "./bussiness.vue?vue&type=script&lang=js"
export * from "./bussiness.vue?vue&type=script&lang=js"
import style0 from "./bussiness.vue?vue&type=style&index=0&id=c9a8cbe4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a8cbe4",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/account/bussiness.vue
// module id = null
// module chunks = 